import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('submit', this.handleSubmit.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('submit', this.handleSubmit.bind(this))
  }

  handleSubmit(event) {
    event.preventDefault()
    
    const form = event.target
    const formData = new FormData(form)
    const url = new URL(form.action)
    
    // Filter out empty fields
    for (const [key, value] of formData.entries()) {
      if (value && value.trim() !== '') {
        url.searchParams.append(key, value.trim())
      }
    }
    
    // Navigate to the filtered URL
    window.location.href = url.toString()
  }
} 